import { Box, Button, Grid, Link, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'

import { IAddressabilityFunnelResponse } from '../types'

interface IProps {
  data: IAddressabilityFunnelResponse
  onMaioridadeClick?(): void
  onCargoClick?(): void
  onRegiaoLotacaoClick?(): void
}

const fmt = new Intl.NumberFormat('pt-BR')
const pct = (v: number) => `${v.toFixed(1)}%`

export function AddressabilityFunnel({ data, onMaioridadeClick, onCargoClick, onRegiaoLotacaoClick }: IProps) {
  const losses = data.losses
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="overline" color="text.secondary">Perdas por motivo</Typography>
          <Box sx={{ mt: 1 }}>
            <Row label="Cargo (K9a)" value={losses.cargo} onClick={losses.cargo > 0 ? onCargoClick : undefined} />
            <Row label="Região / Lotação (K9b)" value={losses.regiao_lotacao} onClick={losses.regiao_lotacao > 0 ? onRegiaoLotacaoClick : undefined} />
            <Row label="Tipo de dependente (K9c)" value={losses.tipo_dependente} />
            <Row label="Maioridade (K9d)" value={losses.maioridade} />
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
            Endereçabilidade: {pct(data.pct_enderecabilidade)} • Conversão: {pct(data.pct_conversao)}
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="overline" color="text.secondary">Dependentes próximos da maioridade (K19)</Typography>
            {onMaioridadeClick && data.dependentes_proximos_maioridade.length > 0 && (
              <Button size="small" onClick={onMaioridadeClick}>Ver todos</Button>
            )}
          </Stack>
          <Table size="small" sx={{ mt: 1 }}>
            <TableHead>
              <TableRow>
                <TableCell>Dependente</TableCell>
                <TableCell>Titular</TableCell>
                <TableCell align="right">Dias</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.dependentes_proximos_maioridade.slice(0, 8).map(d => (
                <TableRow key={d.person_tax_payer_id}>
                  <TableCell>{d.person_name ?? d.person_tax_payer_id}</TableCell>
                  <TableCell>{d.titular_name ?? '—'}</TableCell>
                  <TableCell align="right">{d.days_to_max_age}</TableCell>
                </TableRow>
              ))}
              {data.dependentes_proximos_maioridade.length === 0 && (
                <TableRow><TableCell colSpan={3} align="center"><Typography variant="body2" color="text.secondary">Nenhum dependente na janela.</Typography></TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </Grid>
    </Grid>
  )
}

function Row({ label, value, onClick }: { label: string; value: number; onClick?: () => void }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
      <Typography variant="body2">
        {onClick ? (
          <Link component="button" type="button" underline="hover" onClick={onClick}>{label}</Link>
        ) : label}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>{fmt.format(value)}</Typography>
    </Box>
  )
}
